export default __webpack_public_path__ + "static/media/modifiedLogo.04dbf52c.png";